import React from "react";
import AppointmentAgenda from "@/components/AppointmentAgenda";

export default function Dashboard() {
  return <AppointmentAgenda />;
}
